export enum HaendlerGruppe {
  TIER_S = 'TIER_S',
  TIER_A = 'TIER_A',
  TIER_B = 'TIER_B',
  MARKT = 'MARKT',
  DROGERIE = 'DROGERIE',
  NON_FOOD = 'NON_FOOD',
}
